import { firstLetterInCapitals, snakeToCamel } from '~utils/string';

export const ORDER_STATUS = {
  CREATED: 'created',
  PREPARING: 'preparing',
  READY: 'ready',
  HISTORY: 'history',
  PRODUCTS: 'products',
  CANCELED: 'canceled',
  CANCELLED: 'cancelled',
  COMPLETED: 'completed',
  IN_TRANSIT: 'in_transit',
  SCHEDULED: 'creation_scheduled',
  REJECTED_ORDER_MANAGER: 'rejected_order_manager',
  ORDER_TAKER: 'order_taker'
};

export const POS_FAILED_ORDER_STATUS = [
  ORDER_STATUS.CREATED,
  ORDER_STATUS.PREPARING,
  ORDER_STATUS.READY,
  ORDER_STATUS.IN_TRANSIT,
  ORDER_STATUS.COMPLETED,
  ORDER_STATUS.SCHEDULED
];

export const POS_FAILED_HISTORY_ORDER_STATUS = [...POS_FAILED_ORDER_STATUS, ORDER_STATUS.CANCELED];

export const STATE_MACHINE = {
  [ORDER_STATUS.SCHEDULED]: {
    nextState: ORDER_STATUS.CREATED
  },
  [ORDER_STATUS.CREATED]: {
    nextState: ORDER_STATUS.PREPARING
  },
  [ORDER_STATUS.PREPARING]: {
    nextState: ORDER_STATUS.READY
  },
  [ORDER_STATUS.READY]: {
    nextState: ORDER_STATUS.COMPLETED
  }
};

export const mapStatus = (status, dispatchMethod) => {
  if (status !== ORDER_STATUS.READY) {
    return snakeToCamel(status);
  }
  return `${snakeToCamel(status)}${firstLetterInCapitals(dispatchMethod)}`;
};

export const SORT_BY_STATUS_FIELD = {
  [ORDER_STATUS.SCHEDULED]: 'laterStartTime'
};

export const PAYMENT_METHODS = {
  ONLINE: 'online',
  CARD: 'card',
  CASH: 'cash'
};

export const DISPATCH_METHODS = {
  // eslint-disable-next-line camelcase
  in_store: 'inStore',
  delivery: 'delivery',
  // eslint-disable-next-line camelcase
  store_delivery: 'storeDelivery'
};

export const ORDER_TYPE = {
  SCHEDULED: 'scheduled',
  DEFERRED: 'deferred',
  DEFAULT: 'default'
};

export const ORDER_CHANNELS = {
  MERCAT: 'mercat',
  PEYA_AGGREGATOR: 'peya_aggregator',
  rappi: 'rappi',
  UBER_EATS: 'uber_eats',
  AMIPASS: 'amipass'
};
